<template lang="pug">
#rank-icon-card
  p#rank-text {{ $t("result.rank-title") }}
  span.circle {{ result.rank }}
  p#score-text {{ $t("result.score-title") }}: {{ result.score }}
  #twitter-share-btn-area
     button#twitter-share-btn(@click="shareOnTwitter") {{ $t("result.share-twitter-btn-text") }}
  router-link.game-start-btn(v-bind:to="'/'")
    p {{ $t("result.to-top-btn-text") }}
</template>

<script>

import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      resultState: state => state.Result
    }),
    result: function () {
      return this.resultState.result
    }
  },
  methods: {
    shareOnTwitter: function () {
      let tweetText = ''
      let websiteUrl = ''
      let hashtags = ''
      if (this.$i18n.locale === 'ja') {
        tweetText = `タイピングゲーム「タイプで学ぼうコロナ対策！」をやってみました。私はスコアは${this.resultState.result.score}点！ランクは「${this.resultState.result.rank}」でした。みんなもぜひプレイしてみてください。サイトのURLは→`
        websiteUrl = 'https://typing-game-covid-19.web.app'
        hashtags = 'タイプで学ぼうコロナ対策！,コロナ,ステイホーム'
      } else {
        tweetText = `Scored ${this.resultState.result.score} on Type to Beat Covid19. Ranked ${this.resultState.result.rank}!! Let's play together!`
        websiteUrl = 'https://typing-game-covid-19.web.app'
        hashtags = 'TypeToBeatCovid19,coronavirus,covid19,stayhome'
      }
      const url = 'https://twitter.com/intent/tweet?text=' + tweetText + '&url=' + websiteUrl + '&hashtags=' + hashtags
      window.open(url)
    }
  }
}

</script>

<style>

#rank-icon-card {
  width: 50%;
}

#rank-text {
  font-size: 40px;
}

#score-text {
  font-size: 50px;
  margin-top: 30px;
}

.circle{
  display: inline-block;
  width: 160px;
  height: 160px;
  font-size: 90px;
  border-radius: 50% 50% 50% 50%;
  background: rgba(255, 176, 0, 0.7);
  text-align: center;
  line-height: 160px;
  animation: rank-animation 2s linear;
}

@keyframes rank-animation {
  0% {
    opacity: 0;
    transform: rotateY(0deg);
  }
  100% {
    opacity: 1;
    transform: rotateY(-360deg);
  }
}

#twitter-share-btn-area {
  width: 100%;
  height: 40px;
  text-align: center;
  margin-bottom: 40px;
}

#twitter-share-btn {
  background-color: #0099FF;
  border-radius: 85px / 55px;
  font-weight: bold;
  color: white;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/ResultRankIcon.vue